import { memo, useEffect, useState } from "react"
import ProductList from "@/components/product/list"
import ProductService from "@/services/product"
import ProductTagService from "@/services/product_tag"
import ProductCategoryService from "@/services/product_category"
import { Box, Button, Spacer, Stack, Text } from "@chakra-ui/react"
import HomeBanner from "./HomeBanner";
import { Tabs } from "@chakra-ui/react"
import { LuCheck, LuFolder, LuSquareCheck, LuUser } from "react-icons/lu"
import _ from "lodash"
import { useStore } from "contexts/store"
import Default from "./Default"
import { useApp } from "contexts/app"
import Custom from "./Custom"



const Home = () => {
    const { setProcessing, setPageTitle, showToast, showConfirm, printPdf } = useApp();
    const { store } = useStore();
    useEffect(() => {
        setPageTitle(store?.web?.title || "Trang chủ")
    }, [setPageTitle, store?.web?.title])

    if (store.home_page?.display == "custom") {
        return <Custom></Custom>
    }

    return <Default></Default>
}

export default memo(Home)